module.exports = __webpack_public_path__ + "img/pfa.50eb2b03.svg";